angular.module('unica_notification.notification_controllers', [])

.controller('NotificationBasicController',
	function(
		$rootScope, $scope, $stateParams,
		NotificationTemplateListService, NotificationListService
	) {

	$scope.forms = {};

	$scope.event_id = $stateParams.event_id;

	$scope.notificationTemplateList = [];
	$scope.getNotificationTemplateList = function()
	{
		$rootScope.showLoader();

		NotificationTemplateListService
			.list($scope.event_id)
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.notificationTemplateList = data;

					$scope.$broadcast('notification_template_list_loaded');
				}
			});
	};

	$scope.notificationData = { };

	$scope.resetNotificationData = function()
	{
		$scope.notificationData = { };
	};

	$scope.getNotification = function(id)
	{
		$rootScope.showLoader();

		NotificationListService
			.get( id )
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.notificationData = data;
					$scope.$broadcast('notification_loaded');
				}
			});
	};

});